export default __webpack_public_path__ + "static/media/xtreme-project-4.15ac04f5.jpg";